import { EChartsType } from 'echarts';
import { useRef, useEffect, RefObject } from 'react';

/**
 * 监听图例点击切换
 *
 * @param echartRef EChart 引用
 * @param options
 */
export const useLegendChange = (
  echartRef: RefObject<EChartsType>,
  options?: {
    deps?: React.DependencyList;
    legendChangeCallback?: ({
      selectedItems,
      datasets,
      echartRef,
    }: {
      selectedItems: Record<string, boolean>;
      datasets: Array<{ source?: Record<string, unknown> }>;
      echartRef: RefObject<EChartsType>;
    }) => void;
  },
) => {
  const echartRenderOptions = useRef<echarts.EChartsOption | null>(null);

  useEffect(() => {
    const echartIns = echartRef.current;
    if (!echartIns) {
      return;
    }

    const afterRenderFinished = () => {
      if (echartRenderOptions.current !== null) {
        return;
      }

      const echartOptions = echartIns?.getOption() as echarts.EChartsOption;
      echartRenderOptions.current = echartOptions;
    };

    echartIns?.on('finished', afterRenderFinished);

    const handleLegendSelectChanged = (params: {
      name: string;
      type: string;
      selected: Record<string, boolean>;
    }) => {
      const echartOptions = echartRenderOptions.current;
      if (!(echartOptions && Array.isArray(echartOptions.dataset))) {
        return;
      }

      options?.legendChangeCallback &&
        options.legendChangeCallback({
          selectedItems: params.selected,
          datasets: echartOptions.dataset as Array<{ source?: Record<string, unknown> }>,
          echartRef,
        });
    };

    echartIns?.on('legendselectchanged', handleLegendSelectChanged);

    return () => {
      echartIns?.off('finished', afterRenderFinished);
      echartIns?.off('legendselectchanged', handleLegendSelectChanged);
    };
  }, [echartRef, options?.deps]);
};
